<template>
  <div class="LKReportsRoadmapCommonTitle">
    <BLayoutExpansion
      title="Результат по Мерам"
      style="margin-bottom: 16px;"
    >
      <v-row dense>
        <v-col cols="6">
          <BTextField
            :value="data.event_done_count"
            label="Выполнено"
            disabled
            :skeleton="skeleton"
          />
        </v-col>

        <v-col cols="6">
          <BTextField
            :value="data.event_in_progress_count"
            label="Выполнение"
            disabled
            :skeleton="skeleton"
          />
        </v-col>

        <v-col cols="12" lg="6">
          <BTextField
            v-model="data.event_needs_check_count"
            label="Требуется доработка"
            disabled
            :skeleton="skeleton"
          />
        </v-col>

        <v-col cols="12" lg="6">
          <BTextField
            v-model="data.event_undone_count"
            label="Не выполнено"
            disabled
            :skeleton="skeleton"
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <BLayoutExpansion
      title="Отметка о подтверждении"
      style="margin-bottom: 16px;"
    >
      <v-row dense>
        <v-col cols="6">
          <BTextField
            :value="data.event_completed_count"
            label="Подтверждено"
            disabled
            :skeleton="skeleton"
          />
        </v-col>

        <v-col cols="6">
          <BTextField
            v-model="data.event_not_completed_count"
            label="Не подтверждено"
            disabled
            :skeleton="skeleton"
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>
  </div>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'


export default {
  name: 'LKReportsRoadmapCommonTitle',
  components: {
    BLayoutExpansion,
    BTextField,
  },
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>
